import {Component, OnInit, ViewChild} from '@angular/core';
import {DisplayedColumnInf} from '../../interfaces/common/table/displayed-column-inf';
import {DateTimePipe} from '../../pipes/date-time/date-time.pipe';
import {JournalApiService} from '../../services/api/alarms/journal/journal-api.service';
import {ServerPageRequest} from '../../classes/common/table/server-page-request';
import {PageEvent} from '@angular/material/paginator';
import {
  TableColumnsConfigurationDialogComponent
} from '../../dialogs/table-columns-configuration-dialog/table-columns-configuration-dialog.component';
import {AlarmsSearchComponent} from '../components/alarms-search/alarms-search.component';
import {MatDialog} from '@angular/material/dialog';
import {ArmTableComponent} from '../../components/arm-table/arm-table.component';
import {LoaderService} from '../../services/common/loader-service/loader.service';
import {SearchTermDefinitionInf} from '../../interfaces/common/search/search-term-definition-inf';

@Component({
  selector: 'journal',
  templateUrl: './journal.component.html',
  styleUrls: ['./journal.component.scss']
})
export class JournalComponent implements OnInit {

  data = {elements: [], totalElements: 0};
  selection;

  search: any = {};
  alarmsSearchComponent = AlarmsSearchComponent;
  searchData: any;
  searchTerms: SearchTermDefinitionInf[] = [
    {term: 'name', operator: ':', displayName: 'Name'},
    {term: 'source', operator: ':', displayName: 'Source'},
    {term: 'description', operator: ':', displayName: 'Description'},
    {term: 'startDate', operator: '=', displayName: 'Start Date'},
    {term: 'endDate', operator: '=', displayName: 'End Date'},
    {term: 'operator', operator: ':', displayName: 'Operator'},
    {term: 'value', operator: ':', displayName: 'Value'},
    {term: 'action', operator: ':', displayName: 'Action'}
  ];

  @ViewChild(ArmTableComponent) armTable;

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'createDate', display: 'Date And Time', selected: true, width: 50, transformer: DateTimePipe},
    {name: 'source', display: 'Source', selected: true, width: 50},
    {name: 'actionDescription', display: 'Name', selected: true, width: 100},
    {name: 'operator', display: 'Operator', selected: true, width: 80},
    {name: 'description', display: 'Description', selected: true, width: 250},
  ];

  serverPageRequest: ServerPageRequest = new ServerPageRequest({
    pageIndex: 0,
    pageSize: 25,
    length: 0
  });

  constructor(private journalApiService: JournalApiService,
              public dialog: MatDialog,private loaderService: LoaderService) { }

  ngOnInit(): void {
    this.searchData = {type: 'journal'};
    this.refresh();
  }

  onSearch(data): void {
    this.armTable.firstPage();
    this.serverPageRequest.firstPage();
    this.search = data;
    this.refresh();
  }

  refresh(): void {
    const params = {...this.search, ...this.serverPageRequest};
    this.loaderService.showMainContainer();
    this.journalApiService.getJournals(params).subscribe(data => {
      this.data = data;
      this.loaderService.hideMainContainer();
    });
  }

  openColumnsConfiguration(): void {
    const dialogRef = this.dialog.open(TableColumnsConfigurationDialogComponent, {
      width: '350px',
      data: {
        columns: this.displayedColumns
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      dialogRef.close();
    });
  }

  pageChanged(pageInfo: PageEvent): void {
    this.serverPageRequest = new ServerPageRequest(pageInfo);
    this.refresh();
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }
}
